import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../../../services/utils.service';
import { DzongkhaService } from '../../../services/dzongkha.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-dzongkha',
  templateUrl: './new-dzongkha.component.html',
  styleUrls: ['./new-dzongkha.component.scss']
})
export class NewDzongkhaComponent implements OnInit {

  dzongkha = {
    dzongkha: '',
    english: ''
  };
  constructor(private utilsService: UtilsService,
              private graphqlService: DzongkhaService,
              private router: Router) { }

  ngOnInit() { }

  addDzongkha() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.dzongkha['dzongkha'], this.dzongkha['english']);
    if (requiredSuccess) {
      this.graphqlService.create(this.dzongkha).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Dzongkha Created !!', '');
          this.router.navigate(['/dzongkhas']);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to create dzongkha.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/dzongkha/new-dzongkha/new-dzongkha.component.ts